export default "__VITE_ASSET__e9ee009d__"